<template>
    
    <div class="main">
        <form-base :paramId="$route.params.id" v-on:onSubmitInstituicao="onSubmitInstituicao"></form-base>
    </div>
    
</template>
<script>

import formBase from "./form"

export default {
    methods:{

        onSubmitInstituicao(){

            if(this.$store.state.user.tipo >= 2){

                this.$router.push('/admin/instituicao/index');            
            }
        }
    },
    components:{ formBase }
}
</script>
